<template>
  <header>
    <!--Хедер десктопный-->
    <div class="header desktop">
      <div class="menu-btn" @click="showLeftMenu">
      <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="67" height="60" viewBox="0 0 67 60" version="1.1" id="svg12" sodipodi:docname="menu.svg" inkscape:version="0.92.3 (2405546, 2018-03-11)" Googl="true">
        <defs id="defs16"/>
        <sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10" gridtolerance="10" guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2" inkscape:window-width="1878" inkscape:window-height="1051" id="namedview14" showgrid="false" inkscape:zoom="13.215062" inkscape:cx="27.789043" inkscape:cy="21.898722" inkscape:window-x="1962" inkscape:window-y="0" inkscape:window-maximized="1" inkscape:current-layer="svg12"/>
        <g id="Page-1" style="fill:#ffffff;fill-rule:evenodd;stroke:none;stroke-width:1" transform="translate(20,19)">
          <g id="Cinema-page" transform="translate(-19,-19)" style="fill:#ffffff">
            <g id="Group-32" transform="translate(19,19)" style="fill:#ffffff">
              <rect id="Rectangle" x="0" y="0" width="27" height="2" style="fill:#ffffff"/>
              <rect id="Rectangle-Copy-2" x="0" y="10" width="27" height="2" style="fill:#ffffff"/>
              <rect id="Rectangle-Copy-3" x="0" y="20" width="27" height="2" style="fill:#ffffff"/>
            </g>
          </g>
        </g>
      </svg>
      </div>
       <a class="logolink desktop" href="https://multiplex.ua">
          <img src="../assets/img/preloader_dt.svg" alt="loading..." style="position: absolute;">
        </a>
      <p class="cutted" @click="showLeftMenu">
        <span itemscope="" itemtype="http://data-vocabulary.org/Breadcrumb">
          <a itemprop="url" href="#" class="brcr_link">
            <span itemprop="title">{{ $t("header.heading") }}</span>
          </a>
        </span>
      </p>
        <div class="geo" v-if="user">
          <div class="profile">
            <!-- <div class="avatar" v-if="user"> -->
            <!-- <div class="avatar"> -->
              <!-- <div class="img_ava" :style="{ 'background-image': 'url(' + user.avatar + ')' }" v-if="user.avatar"></div> -->
              <!-- <div class="img_ava" v-else> -->
              <!-- <div class="img_ava">
                <img src="../assets/img/ava_temp.svg" alt="ava">
              </div> -->
            <!-- </div> -->
            <a class="header-logout" :href="logoutURL">
              {{ $t("pop_ups.left_menu.logout") }}
              <span>
                <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h30v30H0z"/><path d="M15.064 9.614a1 1 0 0 0 .229 1.093L18.586 14H8a1 1 0 1 0 0 2h10.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l4.912-4.912a1 1 0 0 0-.002-1.592l-4.91-4.91a1 1 0 0 0-1.643.321z" fill="#FFF" fill-rule="nonzero"/></g></svg>
              </span>
            </a>
          </div>
        </div>
    </div>
    
  
    <!--Мобильный хедер-->
    <div class="mobile_header">
      <a class="logo" href="https://multiplex.ua" v-show="!mobMenuVisible">
        <img src="../assets/img/preloader_dt.svg" alt="Multiplex">
      </a>
      <!-- <div class="hamb_holder mob-menu-btn" >
        <div class="hamburger">
          <span></span>
        </div>
      </div> -->
      <div class="mh_texts" v-show="!mobMenuVisible">
        <p class="top">{{ $t("header.heading") }}</p>
      </div>
    </div>
    <div id="nav-icon3" :class="{'open': mobMenuVisible}" @click="mobMenuVisible ? hideMobMenu() : showMobMenu()">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </header>
</template>
<script>
import Store from '../store'

export default {
  computed: {
    user: function () {
      return Store.state.user
    },
    mobMenuVisible: function () {
      return Store.state.mobMenuVisible
    },
    logoutURL: function () {
      return Store.state.logoutURL
    }
  },
  methods: {
    showMobMenu: function () {
      Store.commit('showMobMenu')
    },
    hideMobMenu: function () {
      Store.commit('hideMobMenu')
    },
    showLeftMenu: function () {
      Store.commit('showLeftMenu')
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?7280d000